<template>
  <div class="pa-2">
    
    <TotalAndAssignedCards
      :dataLoaded="dataLoaded"
      :totalItems="totalItems"
      :totalSubItems="totalSubItems"
      :totalAssignedToYourTeams="totalAssignedToYourTeams"
      :totalAssignedToYou="totalAssignedToYou"
      :showOpenItemsOnly="showOpenItemsOnly"
      v-model:filterByMyTeams="filterByMyTeams"
      v-model:filterByMe="filterByMe"
      @filterChange="handleCardFilterChange"
      @update:showOpenItemsOnly="reloadWithOpenItemsOnly"
    />

    <CategorySubcategoryList
      :categories="categories"
      :subcategories="subcategories"
      :statusCounts="statusCounts"
      :loading="summaryLoading"
    />

    <!-- Items Data Table -->
    <v-row>
      <v-col cols="12">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="table"
          height="400"
        ></v-skeleton-loader>
        <ItemsGrid v-else v-bind="grid" />
      </v-col>
    </v-row>
  </div>
</template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
